import { jsx as m } from "react/jsx-runtime";
import s from "clsx";
import t from "./Toast.module.css.js";
import { Pressable as a } from "../Pressable/index.js";
const l = ({ children: r, ...o }) => /* @__PURE__ */ m(a, { className: s(t.anchor, o.className), ...o, children: r });
export {
  l as ToastAnchor
};
//# sourceMappingURL=Anchor.js.map
